import React from "react";
import { FormGroup, FormLabel, FormControl } from "react-bootstrap";

const FieldGroup = ({ label, required, id, value, defaultValue, readOnly, disabled, ...props }) => {
    const isControlled = value !== undefined;

    return (
        <FormGroup>
            {label && (
                <FormLabel htmlFor={id}>
                    {label} {required && <span className="text-danger-1">*</span>}
                </FormLabel>
            )}
            <FormControl
                id={id}
                required={required}
                readOnly={readOnly}
                disabled={disabled}
                {...props}
                {...(isControlled ? {value} : {defaultValue})}
            />
        </FormGroup>
    );
};

const FormInputs = ({ ncols, proprieties }) => (
    <div className="row">
      {ncols.map((colClass, i) => (
          <div key={i} className={colClass}>
            <FieldGroup {...proprieties[i]} />
          </div>
      ))}
    </div>
);

export default FormInputs;